import React, { ReactNode, useState } from 'react';
import classNames from 'classnames';
import { ReactComponent as ArrowIcon } from './arrow.svg';
import './Panel.pcss';

type Props = {
  className?: string;
  title: string;
  children: string | ReactNode | Element[];
};

export const Panel = ({ className, title, children }: Props) => {
  const [isActive, setIsActive] = useState<boolean>();
  const toggle = () => setIsActive(!isActive);
  return (
    <div
      className={classNames(className, 'sign-up-panel', {
        'sign-up-panel--active': isActive,
      })}
    >
      <div className="sign-up-panel__header" onClick={toggle}>
        <div className="sign-up-panel__title">{title}</div>
        <div className="sign-up-panel__icon">
          <ArrowIcon />
        </div>
      </div>
      {isActive && <div className="sign-up-panel__content">{children}</div>}
    </div>
  );
};
